/*
  注意：要想使用此文件中的handleUploadSuccess函数，vue组件中获取列表数据的函数名需为“getData”
*/
import { Vue, Component } from "vue-property-decorator";
import Cookies from "js-cookie"; // 因为token 的问题引入cookies
import { getToken } from "../utils/auth";
import {
  downloadTeacherInfo,
  exportTeacherInfo,
  exportTeacherSubjectSupplement,
  exportAuditTeacherInfo,
  downloadMarkQuality,
  exportMarkQuality,
  downloadMarkingTeacherEvaluateTemplate,
  exportMarkingTeacherChoose,
  exportMarkingEmployManage,
  exportEmployInfo,
  exportMarkHistoryStatistics,
  exportLog,
  downloadErrorFile,
  exportPropositionTeacherEmploy,
  exportPropositionTchEvaluate,
  exportExaminerEmploy,
  exportExaminerEvaluate,
  exportProjectMsgManage,
  downloadDistrictTemplate,
  downloadSchoolTemplate,
  downloadProjectManageTemplate,
  downloadAuditTeacherInfo,
  downloadTeacherMaintainTemplate,
  exportTeacherMaintain
} from '@/api/downloadAndExport'

@Component
export default class importAndExportMixin extends Vue {
  private fileApi = {
    downloadTeacherInfo,
    exportTeacherInfo,
    exportTeacherSubjectSupplement,
    exportAuditTeacherInfo,
    downloadMarkQuality,
    exportMarkQuality,
    downloadMarkingTeacherEvaluateTemplate,
    exportMarkingTeacherChoose,
    exportMarkingEmployManage,
    exportEmployInfo,
    exportMarkHistoryStatistics,
    exportLog,
    downloadErrorFile,
    exportPropositionTeacherEmploy,
    exportPropositionTchEvaluate,
    exportExaminerEmploy,
    exportExaminerEvaluate,
    exportProjectMsgManage,
    downloadDistrictTemplate,
    downloadSchoolTemplate,
    downloadProjectManageTemplate,
    downloadAuditTeacherInfo,
    downloadTeacherMaintainTemplate,
    exportTeacherMaintain
  }
  private progressData = {
    uuid: -1,
    fileName: '',
    progressVisible: false,
    uploadStatus: 'uploading',
  };
  private upload = {
    header: {
      Authorization: getToken() == undefined ? Cookies.get("access_token") : getToken(),
      access_token: getToken() == undefined ? Cookies.get("access_token") : getToken(),
    },
    fileList: []
  }; //上传文件

  //上传之前限制附件格式
  private beforeUploadHandle(file) {
    // 上传之前必须选择项目的校验
    if (this['projectId'] === '') {
      this.$message.warning("请选择项目！");
      return false;
    }
    let name = file.name;
    let suffix = name.substring(name.lastIndexOf(".") + 1);
    let format = ["xlsx"];
    if (format.indexOf(suffix) === -1) {
      this.$message.error("请上传xlsx格式的文件");
      //不满足条件，return false 阻止上传
      return false;
    }
    window['$showLoading']('#app');

    if (this['uploadData'] && (this as any).uploadData.progressId) {
      this.openUploadDialog();
    }
  }


  //上传之前限制附件格式
  private beforeAuditUploadHandle(file) {
    // 上传之前必须选择项目的校验
    if (this['projectId'] === '') {
      this.$message.warning("请选择项目！");
      return false;
    }

    if (this['sourceId'] === '') {
      this.$message.warning("请选择来源！");
      return false;
    }
    let name = file.name;
    let suffix = name.substring(name.lastIndexOf(".") + 1);
    let format = ["xlsx"];
    if (format.indexOf(suffix) === -1) {
      this.$message.error("请上传xlsx格式的文件");
      //不满足条件，return false 阻止上传
      return false;
    }
    window['$showLoading']('#app');
  }


  // 控制上传进度窗口
  private openUploadDialog() {
    // 获取当前时间戳
    const date = +new Date();

    // 打开上传文件窗口获取进度
    this.progressData = {
      uuid: date,
      fileName: name,
      progressVisible: true,
      uploadStatus: 'uploading',
    };

    // 设置上传接口入参
    this.setUploadParams(date);
  }

  // 设置上传数据参数
  private setUploadParams(date: number) {
    const that = this as any;
    Object.keys(that.uploadData).forEach(key => {
      if (key !== 'progressId') {
        that.uploadData[key] = that[key];
      }
    });
    that.uploadData.progressId = date;
  }

  //上传成功的处理,参数cb是上传成功后要执行的函数
  private async handleUploadSuccess(res: any, errorFileName: string, cb: Function) {
    window['$hideLoading']();
    // 根据后台状态码判断
    if (res.code != "20000000") {
      this.$message.error(res.mesg)
    } else {
      if (res.data) {
        if (res.data.total === res.data.totalSuccess) {
          this.$message.success("上传成功");
        } else {
          this.$message.error("导入失败");
          this.$confirm('是否确定下载错误文件?', '温馨提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(async () => {
              await this.downloadHandle("downloadErrorFile", errorFileName, {errorFileId: res.data.errorFileId});
            })
            .catch(e => {
            });
        }
      }
    }
    if (cb) {
      cb();
    } else {
      (this.$refs.upload as any).clearFiles();
      this.upload.fileList = [];
    }
    // 关闭文件上传进度
    setTimeout(() => {
      this.progressData.uploadStatus = 'done';
    }, 500);
    //获取列表数据
    (this as any).getData();
  }

  //上传失败的处理
  private handleUploadError(err) {
    window['$hideLoading']();
    let messsage = JSON.parse(err.message);
    this.$message.error(messsage.mesg);
  }

  //下载文件，参数为“发送请求的函数”、“下载后的文件名（带上后缀）”、“需携带的请求参数”
  private async downloadHandle(requestFn, fileName, requestParams) {
    try {
      let res: any = {};
      window['$showLoading']('#app');
      const fn = this.fileApi[requestFn];
      if (fn) {
        res = requestParams ? await fn(requestParams) : await fn();
      }
      window['$hideLoading']();
      const blob: Blob = new Blob([res], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
      });
      // IE兼容处理
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName)
      } else {
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.style.display = "none";
        downloadElement.href = href;
        downloadElement.download = `${fileName}`; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
        this.$message.success("下载成功");
      }
    } catch (error) {
      window['$hideLoading']();
      // this.$message.error(error || "下载失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }
}
